import React, { useState, useEffect } from 'react';
import { Card, Table, Tooltip, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { fetchMCPServerApps } from './MCPServerApis';
import CciCloud from '../../common/components/CciCloud/CciCloud';
import AppAdditionModal from './components/AppAdditionModal';
import { MCPAppCompletionStatus } from '../../common/constants';
import { getAppStatus } from './MCPServerHelper';
const { Title } = Typography;

const MCPServer = () => {
    const tableColumns = [
        {
            title: 'App ID',
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            render: (text, record) => <a href={`/mcpresearch/${record.id}`}>{text}</a>,
        },
        {
            title: 'App Name',
            dataIndex: 'display_name',
            key: 'display_name',
            fixed: 'left',
            render: (text, record) => (
                <Tooltip title={record.name}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Endpoint URL',
            dataIndex: 'endpoint_url',
            key: 'endpoint_url',
            render: (text) => (
                <a target='_blank' href={text}>
                    {text}
                </a>
            ),
        },
        {
            title: 'Category',
            dataIndex: 'category_id',
            key: 'category_id',
            render: (text, record) => record?.MCPServerCategory?.category_name ?? '-',
        },
        {
            title: 'Classification',
            dataIndex: 'classification',
            key: 'classification',
        },
        {
            title: 'CCL',
            dataIndex: 'ccl',
            key: 'ccl',
            render: (text, record) => <CciCloud cci={record.cci} showLabel />,
        },
        {
            title: 'Completion Status',
            dataIndex: 'MCPServerResearchData',
            key: 'MCPServerResearchData',
            filters: [
                {
                    text: MCPAppCompletionStatus.APP_ASSIGNED.label,
                    value: MCPAppCompletionStatus.APP_ASSIGNED.key,
                },
                {
                    text: MCPAppCompletionStatus.APP_ALL_COMPLETE.label,
                    value: MCPAppCompletionStatus.APP_ALL_COMPLETE.key,
                },
                {
                    text: MCPAppCompletionStatus.APP_COMPLETED_BY_ML.label,
                    value: MCPAppCompletionStatus.APP_COMPLETED_BY_ML.key,
                },
            ],
            onFilter: (value, record) => record.MCPServerResearchDatum?.completion_status.indexOf(value) === 0,
            // sorter: (a, b) => a?.MCPServerResearchDatum?.completion_status.length - b?.MCPServerResearchDatum?.completion_status.length,
            render: (text, record) => getAppStatus(record?.MCPServerResearchDatum?.completion_status ?? '-'),
        },
    ];

    const [mcpServerApps, setMcpServerApps] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const fetchApps = async () => {
        setLoading(true);
        fetchMCPServerApps()
            .then((data) => {
                setMcpServerApps(data);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchApps();
    }, []);

    const onSuccessAddApp = () => {
        fetchApps();
        setOpenModal(false);
    };

    return (
        <div className='container'>
            <div className='ns-flex ns-flex_vertical ns-flex_centered'>
                <Title style={{ marginBottom: 'auto' }} level={2}>
                    MCP Server
                </Title>
            </div>
            <Card
                title='MCP Server Apps'
                size='small'
                headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                extra={
                    <Tooltip title={'Add MCP Server App'}>
                        <PlusOutlined style={{ cursor: 'pointer' }} onClick={() => setOpenModal(true)} />
                    </Tooltip>
                }
            >
                <Table
                    rowKey='id'
                    size='small'
                    bordered
                    dataSource={mcpServerApps}
                    columns={tableColumns}
                    loading={loading}
                    pagination={false}
                />
            </Card>
            <AppAdditionModal open={openModal} onSuccess={onSuccessAddApp} onClose={() => setOpenModal(false)} />
        </div>
    );
};

export default MCPServer;
